type ScriptDescriptor = React.JSX.IntrinsicElements['script'] | undefined;

/**
 * Imperatively injects a script descriptor (the same shape used by the
 * declarative TanStack `scripts` route option) into the document head.
 *
 * Used to load trackers *after* their OneTrust consent category is granted —
 * the declarative route option can't react to mid-session consent changes.
 *
 * No-ops when the descriptor is undefined (e.g. trackers disabled outside
 * production) or when a script with the same `id` has already been injected.
 */
export function injectScript(descriptor: ScriptDescriptor, id: string): void {
  if (!descriptor || typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(id)) {
    return;
  }

  const { children, src, async, type } = descriptor;

  const element = document.createElement('script');
  element.id = id;

  if (type) element.type = type;

  if (src) {
    element.src = src;
    if (async) element.async = true;
  } else if (typeof children === 'string') {
    element.text = children;
  }

  document.head.appendChild(element);
}
